export default function () {
    var elements = document.querySelectorAll('.c-vacancyfilter__navigation__item.btn');
    var clearfilter = document.getElementsByClassName('clearfilter');
    var filternav = document.getElementById('filternav');
    const filteroptions = document.querySelectorAll('.filteroptions.active');
    const vacancyoverview = document.querySelectorAll('c-vacancyoverview');

    if (vacancyoverview.length > 0) {
        var filter = function () {
            var filterid = this.getAttribute('data-filterid');
            var filterelement = document.querySelector("[data-filtername='" + filterid + "']");
            filterelement.classList.add('active');
            filternav.classList.remove('show');
        };

        var clearFilter = function () {
            filternav.classList.add('show');
            filteroptions.classList.remove('active');
        };

        for (var i = 0; i < elements.length; i++) {
            elements[i].addEventListener('click', filter, false);
        }

        for (var ci = 0; ci < clearfilter.length; ci++) {
            clearfilter[ci].addEventListener('click', clearFilter, false);
        }

        if (filteroptions.length > 0) {
            filteroptions.forEach(function (element) {

            });
        }
        else {
            filternav.classList.add('show');
        }
    }
};
